export default __webpack_public_path__ + "static/media/tennis-ball.09376791.svg";